// Firebase configuration and initialization
import { initializeApp } from 'firebase/app';
import { getDatabase, ref as firebaseRef, onValue as firebaseOnValue } from 'firebase/database';

// Check if Firebase environment variables are properly configured
const hasValidFirebaseConfig = import.meta.env.VITE_databaseURL && 
  import.meta.env.VITE_databaseURL !== "your-database-url" &&
  import.meta.env.VITE_databaseURL.includes('firebaseio.com') &&
  import.meta.env.VITE_projectId &&
  import.meta.env.VITE_storageBucket &&
  import.meta.env.VITE_projectId !== "demo-project";

// Firebase configuration with development fallbacks
const firebaseConfig = {
  apiKey: import.meta.env.VITE_apiKey || "demo-api-key",
  databaseURL: import.meta.env.VITE_databaseURL || "https://demo-project-default-rtdb.firebaseio.com/",
  projectId: import.meta.env.VITE_projectId || "demo-project",
  storageBucket: import.meta.env.VITE_storageBucket || "demo-project.appspot.com",
  appId: import.meta.env.VITE_appId || "1:123456789:web:abcdef123456"
};

// Initialize Firebase
let app = null;
let database = null;

try {
  // console.log('hasValidFirebaseConfig', hasValidFirebaseConfig);
  // console.log('firebaseConfig', firebaseConfig);
  if (hasValidFirebaseConfig) {
    app = initializeApp(firebaseConfig);
    database = getDatabase(app);
    // console.log('Firebase initialized successfully');
  } else {
    console.warn('Firebase not properly configured. Please set import.meta.env.VITE_APP_FIREBASE_* environment variables for production.');
   
  }
} catch (error) {
  console.error('Firebase initialization failed:', error);
  // Fallback mock database
 
}



// Export wrapper functions for Firebase v10 with validation
export const ref = (db, path) => {
  if (!hasValidFirebaseConfig) {
    console.error(`Firebase not properly configured. Please set import.meta.env.VITE_APP_FIREBASE_* environment variables for production.`);
    return null;
  }
  return firebaseRef(db, path);
};

export const onValue = (dbRef, callback) => {
  if (!hasValidFirebaseConfig) {
    console.error(`Firebase not properly configured. Please set import.meta.env.VITE_APP_FIREBASE_* environment variables for production.`);
    return null;
  }
  return firebaseOnValue(dbRef, callback);
};

export { database };
export default firebaseConfig;
